<template>
  <div class="p-projects-list__item">
    <router-link
      :to="{
        name: 'dashboard',
        params: { projectId: project.id }
      }"
      class="p-projects-list__link"
    >
      <div class="p-projects-list__inner">
        <div class="p-projects-list__header">
          <h2 class="p-projects-list__title c-text--ellipsis">
            {{ project.displayName }}
          </h2>
          <p class="p-projects-list__url c-text--ellipsis">
            {{ project.siteUrl }}
          </p>
        </div>
        <div
          v-if="
            project.isValidGaRefreshToken === '0' ||
              project.isValidGscRefreshToken === '0'
          "
          class="p-projects-list__token"
        >
          <Button
            v-if="project.isValidGaRefreshToken === '0'"
            variant="attention"
            @click="authGaRefreshToken"
            :disabled="isDisabled"
            icon="arrow_r"
          >
            <Icon2 variant="attention" :size="12" />
            GAアカウント連携に問題が発生しました。再設定はこちら
          </Button>
          <Button
            v-if="project.isValidGscRefreshToken === '0'"
            variant="attention"
            @click="authGscRefreshToken"
            :disabled="isDisabled"
            icon="arrow_r"
          >
            <Icon2 variant="attention" :size="12" />
            GSCアカウント連携に問題が発生しました。再設定はこちら
          </Button>
        </div>
      </div>
      <div class="p-projects-list__content">
        <div class="p-projects-list__image">
          <div class="c-image--border c-image--screenshot">
            <img :src="imgUrl" alt="" />
          </div>
        </div>
        <ProjectRanks :project="project" />
      </div>
    </router-link>
    <div class="p-projects-list__action">
      <Button
        radius
        variant="edit"
        :to="{
          name: 'configProject',
          params: { projectId: project.id }
        }"
      >
        <Tooltip variant="btn">
          サイトを編集
        </Tooltip>
      </Button>
      <Button v-if="isAuthority" radius variant="trash" @click="openModal">
        <Tooltip variant="btn">
          サイトを削除
        </Tooltip>
      </Button>
    </div>
    <ModalDeleteProject
      v-if="modal.isActive"
      :project="project"
      @close="closeModal"
      @delete="deleteItem"
    />
  </div>
</template>

<script>
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import ModalDeleteProject from '@/components/projects/ModalDeleteProject';
import ProjectRanks from '@/components/projects/ProjectRanks';
import Tooltip from '@/components/Tooltip';
import apiProjects from '@/api/projects';

export default {
  props: {
    index: {
      type: Number,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Button,
    Icon2,
    ModalDeleteProject,
    ProjectRanks,
    Tooltip
  },
  data() {
    return {
      modal: {
        isActive: false
      }
    };
  },
  computed: {
    imgUrl() {
      if (this.$constants.isDemo) {
        return require('@/assets/img/demo/img-project0' +
          (this.index + 1) +
          '.jpg');
      }
      return (
        'https://s.wordpress.com/mshots/v1/' +
        this.$options.filters.encodeUrl(this.project.siteUrl) +
        '?w=220'
      );
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    hasOrganizations() {
      return this.$store.getters['user/hasOrganizations'];
    },
    isDisabled() {
      return this.hasOrganizations;
    },
    isAuthority() {
      return this.organization.isAuthority;
    }
  },
  methods: {
    authGaRefreshToken(e) {
      e.preventDefault();
      if (this.isDisabled) {
        return;
      }
      apiProjects.authorization.ga.redirect(this.auth.idToken, this.project.id);
    },
    authGscRefreshToken(e) {
      e.preventDefault();
      if (this.isDisabled) {
        return;
      }
      apiProjects.authorization.gsc.redirect(
        this.auth.idToken,
        this.project.id
      );
    },
    deleteItem() {
      this.closeModal();
      this.$emit('delete');
    },
    closeModal() {
      this.modal.isActive = false;
    },
    openModal() {
      this.modal.isActive = true;
    }
  }
};
</script>
